import { render, staticRenderFns } from "./movementmenu.vue?vue&type=template&id=6a444444&"
import script from "./movementmenu.vue?vue&type=script&lang=js&"
export * from "./movementmenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports